import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { AssetManagementService } from 'src/app/services/asset-management.service';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { AuthorService } from 'src/app/services/author.service';
import { ValidationService } from 'src/app/services/validation.service';
import { FileService } from 'src/app/services/file.service';
import { AlertController } from '@ionic/angular';
import { DeepCopyService } from 'src/app/services/deep-copy.service';

@Component({
  selector: 'app-audio-details',
  templateUrl: './audio-details.component.html',
  styleUrls: ['./audio-details.component.scss'],
})
export class AudioDetailsComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;
  @Input('isFromMediaManagementPage') isFromMediaManagementPage: boolean = false;

  public audioFromMediaManagementPage: boolean = false;
  public oldAssetIDToCopy: number = -1;
  public audioSearchTerm: string;
  public searchNotFound: boolean = false;
  public previewMediaAsset:boolean = false;
  
  constructor(
    public authorService: AuthorService,
    public validationService: ValidationService,
    public assetTypeService: AssetTypeService,
    public assetManagementService: AssetManagementService,
    public fileService: FileService,
    public alertController: AlertController,
    public deepCopyService: DeepCopyService,
  ) { }

  ngOnInit() {}    

  async selectFile() {
    let input = document.querySelector('#file-input');

    const alert = await this.alertController.create({
      header: 'Choose Media',
      message: 'You can browse for a file on your computer or select a file from the media management page.',
      cssClass: 'leave-alert quizard-alert',
      buttons: [{
        text: 'Add ' + this.assetType + ' from media management page',
        cssClass: '',
        handler: () => {
          this.currentStepInfo.addFromMediaManagementPage = true;
          this.oldAssetIDToCopy = this.currentStepInfo.uploadProperties.assetIDToCopy;
        }
      }, {
        text: 'Upload from computer',
        cssClass: '',
        handler:  () => {
          if (input) {
            input.click();
          }
        }
      }
      ]
    });
    await alert.present();
  }

  getAudioAsset(): MediaAsset {
    return this.assetInScene.baseAsset as MediaAsset;
  }

  validateAssetName() {
    this.assetInScene.baseAsset.name = this.validationService.removeHtmlTags(this.assetInScene.baseAsset.name);
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e) {
    this.setModalTransparency(1, e);
  }

  setModalTransparency(opacity, event) {
    if(!this.editing) return;
    var audioSettingsModal = document.getElementById('add-media-object-modal');
    audioSettingsModal.style.opacity = opacity;
  }

  updateScaleChanged(event, asset) {
    this.updateScale(event.detail.value, asset)
  }

  updateScale(xScale, asset){
    asset.sceneAssetRelation.xScale = String(xScale);    
    asset.sceneAssetRelation.yScale = String(xScale);
    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }

  previewMedia(){
    this.previewMediaAsset = !this.previewMediaAsset;
  }

}
